exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  word-break: break-all;\n}\n.ellipsis {\n  margin-right: 1.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.zIndex1001 {\n  z-index: 1001 !important;\n}\n.customClass .el-loading-spinner i {\n  font-size: 1.875rem;\n  color: #1588f4;\n  margin-bottom: 1.25rem;\n}\n.customClass .el-loading-spinner .el-loading-text {\n  color: #1588f4;\n  font-size: 1.875rem;\n}", ""]);

// exports
